import type { CascaderOption } from '../types';
import { isSubmenu } from '../util';

const leafIsSuggestion = (option: CascaderOption): boolean => {
  if (isSubmenu(option)) return false;
  return Boolean((option as { isSuggestion?: boolean }).isSuggestion);
};

export const subtreeContainsSuggestionLeaf = (
  option: CascaderOption,
): boolean => {
  if (isSubmenu(option)) {
    if ((option as { isSuggestedBranch?: boolean }).isSuggestedBranch) {
      return true;
    }
    return option.children.some((group) =>
      group.children.some((child) => subtreeContainsSuggestionLeaf(child)),
    );
  }
  return leafIsSuggestion(option);
};
